"use client";
import { Breadcrumb } from "@/components/ui/breadcrumb";
import { useEffect, useMemo } from "react";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { Heading } from "@/components/ui/typography";

export default function AuthHomePage() {
  const t = useTranslations("auth");
  const searchParams = useSearchParams();

  const isDev = process.env.NODE_ENV !== "production";
  const h1w = searchParams?.get("h1w");
  const h1WeightClass = useMemo(() => {
    if (!isDev) return undefined;
    switch ((h1w || "").toLowerCase()) {
      case "bold":
        return "font-bold";
      case "semibold":
        return "font-semibold";
      case "medium":
        return "font-medium";
      default:
        return undefined;
    }
  }, [h1w, isDev]);
  // 设置页面标题
  useEffect(() => {
    const title = t("title");
    if (title) {
      const pageTitle = `${title} | Tukera`;
      document.title = pageTitle;
    }
  }, [t]);
  return (
    <>
      <Breadcrumb items={[{ href: "/auth", name: t("breadcrumb.auth") }]} />
      <div className="max-w-2xl mx-auto py-12 px-4">
        <Heading
          variant="h1"
          as="h1"
          className={`mb-4 text-foreground font-semibold ${h1WeightClass ?? ""}`}
        >
          {t("breadcrumb.auth")}
        </Heading>
        <p className="text-gray-600 dark:text-gray-400">
          {t("welcome.home_welcome")}
        </p>
      </div>
    </>
  );
}
